import { currencyFromSymbol } from 'shared/currency-utilities'
import { RateCurrency } from 'booking/components/utilities'

import styles from './styles.module.scss'

export const PriceToPay = ({ rate, total, rateCurrencySymbol, label, rowStyles }) => (
    <div className={rowStyles}>
        <span className="mr-1">{label}</span>
        <h2 className={styles.totalPrice}>
            <RateCurrency rate={rate} value={total} currency={currencyFromSymbol(rateCurrencySymbol)} />
        </h2>
    </div>
)
